<template>
  <StyledCtaButton
    ref="targetEl"
    :href="ctaLink"
    :text="text"
    :buttonId="buttonId || ''"
    @click="() => handleClick()"
  />
</template>

<script lang="ts">
import { composePopoverForm } from "@fresh8/ad-data-composition/src/popoverForm";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { injectBetData } from "@fresh8/ad-data-composition/src/betData";
import * as generateLinks from "@fresh8/ad-data-composition/src/lib/generateLinks";
import { defineComponent } from "vue";
import StyledCtaButton from "./styled/CtaButton.vue";
import { useAnalytics } from "../hooks/useAnalytics";

export default defineComponent({
  name: "CtaButton",
  components: {
    StyledCtaButton
  },
  props: {
    text: {
      type: String,
      required: true
    },
    href: {
      type: String,
      required: true
    },
    buttonId: {
      type: String,
      required: false
    }
  },
  setup(props) {
    const brandContext = injectBrand();
    const betData = injectBetData();
    const { handleClick } = useAnalytics({}, "CTA Button");
    const ctaLink = generateLinks.cta(props.href, {
      affiliateId: betData?.affiliateId.value,
      clickUrl: betData?.clickUrl.value,
      operatorKey: betData?.operator.value?.name || ""
    });

    const { targetEl } = composePopoverForm("Cta Button", [
      {
        type: "ctaButton",
        get: () =>
          brandContext?.brand.value.adTemplate.header.ctaButton.id || "",
        set: (value: string) => {
          if (brandContext) {
            brandContext.brand.value.adTemplate.header.ctaButton.id = value;
          }
        }
      }
    ]);

    return {
      targetEl,
      ctaLink,
      handleClick
    };
  }
});
</script>

<style></style>
